export default "__VITE_ASSET__C4oC1Wct__"